<template>
  <div class="sign">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="sign-search">
      <div class="btn-box">
        <!-- style="background-color:red;border-color:red;color:#fff;" -->
        <van-field
          size="small"
          v-model="scanCodePallet"
          placeholder="托唛"
          right-icon="scan"
          clear-trigger="always"
          clearable
          @click-right-icon="scanPallet"
          @keyup.13="getList()"
          @input="triggerSearch"
          @keyup="inputNum"
          ref="scanInp"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="list">
      <van-row type="flex" justify="center" align="center">
        <van-col span="8">原库位</van-col>
        <van-col span="8">库存箱数</van-col>
        <van-col span="8">移库箱数({{ this.countchangeNum }})</van-col>
      </van-row>
      <div>
        <van-swipe-cell v-for="(item, index) in list" :key="index">
          <div class="list-div" @click="openModel(item.storages)">
            <p>{{ item.storages }}</p>
            <p>{{ item.boxCount }}</p>

            <p>
              <input
                type="number"
                class="downInp"
                readonly
                v-model="item.changeNum"
              />
            </p>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="清零"
              @click="toDelete(index)"
            />
          </template>
        </van-swipe-cell>
      </div>

      <div class="submit-box">
        <p>
          <van-field
            size="small"
            v-model="scanLocationCode"
            placeholder="新库位"
            right-icon="scan"
            @click-right-icon="scanStorage"
            @focus="storageFocus"
            ref="storage"
          />
        </p>
        <p><button class="submit-btn" @click="submit">确认提交</button></p>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :title="`库位 ${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="digit"
          size="small"
          placeholder="请输入移库箱数"
          v-model="saveNum"
        />
      </div>
    </van-dialog>

    <!-- <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup> -->
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  getDeliveryInventory,
  deliveryInventoryChange,
} from "@/api/mobile/jy-changeInventory_api";

import { getWarehouseLocation } from "@/api/mobile/stock_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: {},
      scanLocationCode: "",
      scanCodePallet: "",
      show: false,
      saveLocationCode: "",
      saveNum: "",
      refuseReason: "",
      showErrStr: "",
      isAutoOpen: false,
      successStr: "",
      scanskuStorageCommon: {},
      newskuStorageCommonList: [],
      countchangeNum: 0,
      totle: 0,
      showPicker: false,
      columns: [],
      loading: false,
      focusType: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    // document.querySelector('.van-field__right-icon').style.color = '#ffffff'
    // document.querySelector('.van-field__control').style.color = '#ffffff'
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
    },
    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "storageName";
    },

    // storageChange() {
    //   const _warehouse = window.localStorage.warehouse
    //     ? JSON.parse(window.localStorage.warehouse)
    //     : this.warehouse;
    //   const { warehouseId } = _warehouse;
    //   if (!this.scanLocationCode) return;

    //   const data = { locationCode: this.scanLocationCode, warehouseId };
    //   this.loading = true;

    //   getWarehouseLocation(data).then((res) => {
    //     this.loading = false;
    //     if (res.status === 200) {
    //       const { response } = res;

    //       try {
    //         let arr = [];
    //         response.forEach((item) => {
    //           arr.push(item.locationCode);
    //         });
    //         this.columns = arr;
    //       } catch {}
    //     } else {
    //       Toast.fail(res.msg);
    //     }
    //   });
    // },
    onConfirm(val) {
      this.scanLocationCode = val;
      this.showPicker = false;
    },
    triggerSearch() {},

    getList() {
      this.showErrStr = "";
      this.successStr = "";
      if (this.scanCodePallet == "") {
        Toast("请输入托唛");
        return;
      }
      const data = {
        scanCodePallet: this.scanCodePallet,
      };
      Toast.loading({
        message: "查询中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      getDeliveryInventory(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.list = res.response;
          this.countchangeNum=0;
          // 判断this.list是否有数据，并且this.scanCodePallet是否有值
          if (this.list && this.list.length > 0 && this.scanCodePallet) {
            // 把this.list中的字段changeNum更新为boxCount
            this.list.forEach((item, index) => {
              if (item.boxCount) {
                this.$set(this.list[index], "changeNum", item.boxCount);
                this.countchangeNum+=item.boxCount;
              }
            });
            // 把输入焦点放到scanLocationCode下拉框控件上
            this.$nextTick(() => {
              if (this.$refs.storage) {
                this.$refs.storage.focus();
              }
            });
            
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(code) {
      this.show = !this.show;
      this.saveLocationCode = code;
      this.isAutoOpen = false;
      this.successStr = "";
    },

    confirm() {
      this.list.forEach((item, i) => {
        if (item.storages === this.saveLocationCode) {
          if (this.saveNum > item.totalQty) {
            Toast("转化数不可大于库存数");
            this.saveNum = 0;
          }
          this.$set(this.list[i], "changeNum", this.saveNum || 0);
        }
      });
      const s = this.saveNum;
      if (this.isAutoOpen) {
        this.showErrStr = "";
        this.successStr = `库位 ${this.saveLocationCode} 扫入成功，数量${s}`;
      }
      this.saveNum = "";

      var arr2 = [];
      this.list.forEach((item, index) => {
        if (item.changeNum) {
          arr2.push(item.changeNum);
        }
      });
      this.countchangeNum = arr2.reduce(
        (prev, cur) => Number(prev) + Number(cur)
      );
    },

    toDelete(i) {
      this.countchangeNum = this.countchangeNum - this.list[i].changeNum;
      this.$set(this.list[i], "changeNum", 0);
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      console.info(this.list.length);
      if (this.list.length == undefined) {
        this.showsound(false);
        Toast.fail("请输入单号并查询");
        return;
      }
      if (this.scanLocationCode == "") {
        this.showsound(false);
        Toast.fail("请输入新库位");
        return;
      }
      let changeStorageList = [];
      let isDiff=false;
      this.list.forEach((item, index) => {
        if (item.changeNum) {
          const { storages, changeNum, scanCodeID } = item;
          if(storages==this.scanLocationCode)
          {
            isDiff=true;
          }
          var _item = {
            scanCodeID: scanCodeID,
            storages: storages,
            changeNum: changeNum,
          };
          changeStorageList.push(_item);
        }
      });
      if(isDiff)
      {
        this.showsound(false);
          Toast.fail("存在新旧库位相同,请确认");
          return;
      }
      if (changeStorageList.length == 0) {
        this.showsound(false);
        Toast.fail("请在旧库位录入移库数量");
        return;
      }
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const data = {
        WarehouseID: _warehouse.warehouseId,
        NewLocationCode: this.scanLocationCode,
        ScanCodeID: changeStorageList[0].scanCodeID,
        ScanCode: this.scanCodePallet,
        ChangeStorageList: changeStorageList,
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      deliveryInventoryChange(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          console.info(res.msg);
          Toast.success(res.msg);
          setTimeout(() => {
            // 清空scanCodePallet、list、countchangeNum和scanLocationCode
            this.scanCodePallet = "";
            this.scanLocationCode = "";
            this.list = [];
            this.countchangeNum = 0;
            //this.scanLocationCode = "";
            // 把文本焦点放在scanCodePallet
            this.$nextTick(() => {
              if (this.$refs.scanInp) {
                this.$refs.scanInp.focus();
              }
            });
          }, 500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    scanPallet() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanCodePallet = a.resultStr;
          that.getList();
        },
      });
    },
    scanStorage() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanLocationCode = a.resultStr;
        },
      });
    },
  },
};
</script>

<style>
.van-picker__confirm,
.van-picker__cancel {
  font-size: 20px;
}
</style>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}

.submit-box {
  position: static;
  margin: 20px 0;
  > p:first-child {
    max-width: 95%;
    margin: 0 auto;
  }
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}

.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}

.sign-search .btn-box {
  flex: 0.6;
}

.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 36px;
  display: flex;
  align-items: center;
}

.sign-toSearch {
  width: 100%;
  height: 100%;
  min-height: 36px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>